import { PackageItem } from './package-item.model';

export class ListPackageObject {
    data: Array<PackageItem> = [];
    page: number;
    maxSize: number;
    sort: string = '';
    propertiesSort: string = '';
    totalElement: number;

    constructor(data = null) {
        data = data || {};
        this.data = [];
        if (data.data && data.data instanceof Array) {
            data.data.forEach((item) => {
                this.data.push(new PackageItem(item));
            });
        }

        this.page = data.page;
        this.maxSize = data.maxSize;
        this.sort = data.sort || '';
        this.propertiesSort = data.propertiesSort || '';
        this.totalElement = data.totalElement;
    }
}